import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { useQuery } from "@tanstack/react-query";

interface PlatformSettings {
  iOSAppEnabled: boolean;
  physicalProductsEnabled: boolean;
}

export const usePlatformSettings = () => {
  const { client } = useAuthContext();

  const getPlatformSettings = async (): Promise<PlatformSettings> => {
    if (!client)
      throw new Error("UsePlatformSettingsStore: Client not initialized");

    const { data, error } = await client
      .from("platform_settings")
      .select("*")
      .single();

    if (error) throw error;

    return {
      iOSAppEnabled: data.ios_app_enabled,
      physicalProductsEnabled: data.physical_products_enabled,
    };
  };

  const {
    data: settings,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: [],
    queryFn: getPlatformSettings,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    enabled: true,
  });

  return {
    settings,
    refetch,
    isLoading,
    isFetching,
    isError,
  };
};
